export const PERSONAL_HUB_SECTION_DASHBOARD = 'dashboard';
export const PERSONAL_HUB_SECTION_HANGAR = 'hangar';
export const PERSONAL_HUB_SECTION_BLUEPRINTS = 'blueprints';
export const PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS = 'factions-reputations';

export const PERSONAL_HUB_SECTION_IDS = [
  PERSONAL_HUB_SECTION_DASHBOARD,
  PERSONAL_HUB_SECTION_HANGAR,
  PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS,
  PERSONAL_HUB_SECTION_BLUEPRINTS,
];

export function resolvePersonalHubSection(sectionParam) {
  if (!sectionParam) return PERSONAL_HUB_SECTION_DASHBOARD;
  return PERSONAL_HUB_SECTION_IDS.includes(sectionParam)
    ? sectionParam
    : PERSONAL_HUB_SECTION_DASHBOARD;
}

export function personalHubSectionPath(section) {
  return section === PERSONAL_HUB_SECTION_DASHBOARD
    ? '/members/personalhub'
    : `/members/personalhub/${section}`;
}

export function personalHubRailBtnModifier(sectionId) {
  return `personal-hub-rail__btn--${sectionId}`;
}

export const PERSONAL_HUB_RAIL_ITEMS = [
  {
    id: PERSONAL_HUB_SECTION_DASHBOARD,
    resourceKey: 'private.navbar.personalhub',
    action: 'read',
    description: 'Personal hub — dashboard',
    labelKey: 'personalHubDashboard',
  },
  {
    id: PERSONAL_HUB_SECTION_HANGAR,
    resourceKey: 'private.navbar.personalhub.hangar',
    action: 'read',
    description: 'Personal hub — hangar',
    labelKey: 'personalHubHangar',
    lockedMessageKey: 'personalHubExclusiveMembersOnly',
  },
  {
    id: PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS,
    resourceKey: 'private.navbar.personalhub.factionsReputations',
    action: 'read',
    description: 'Personal hub — factions reputations',
    labelKey: 'personalHubFactionReputation',
    lockedMessageKey: 'personalHubExclusiveMembersPlusRankOnly',
  },
  {
    id: PERSONAL_HUB_SECTION_BLUEPRINTS,
    resourceKey: 'private.navbar.personalhub.blueprints',
    action: 'read',
    description: 'Personal hub — blueprints',
    labelKey: 'personalHubBlueprint',
    lockedMessageKey: 'personalHubExclusiveMembersPlusRankOnly',
  },
];
